import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DcmShortcutSvg = function DcmShortcutSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#prefix__a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#171717",
        fillRule: "evenodd",
        d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M2.368 9.007v-.514h.034l.602.001.288.001.296.002c.195 0 .381.003.53.005 1.993.038 3.017.864 3.296 2.308a9 9 0 0 0-2.085-1.174 2 2 0 0 0-.353-.132 9 9 0 0 0-2.608-.497m8.119 5.99a3.2 3.2 0 0 0 .786.093c1.706 0 2.417-1.066 2.565-2.25h-1.156c-.13.72-.617 1.332-1.44 1.332-1.035 0-1.625-.742-1.625-2.452 0-1.697.59-2.399 1.625-2.399.823 0 1.31.545 1.44 1.26h1.156c-.126-1.215-1.143-2.178-2.565-2.178-1.792 0-2.857 1.214-2.866 3.276a9 9 0 0 1 2.08 3.318m5.705-5.068V15H15.08V8.493h1.566l1.706 4.973 1.723-4.973h1.557V15h-1.111V9.897L18.806 15h-.913z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "currentColor",
        d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "prefix__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  });
};
export var DcmShortcut = function DcmShortcut(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: DcmShortcutSvg
  }));
};